// Offer Includes Badges Component
// Displays badges showing which previous offers are included

import { OFFERS } from "./offers-config.ts";

class OfferIncludesBadges extends HTMLElement {
  connectedCallback() {
    this.render();
  }

  private render() {
    const includesAttr = this.getAttribute("includes");
    if (!includesAttr) return;

    let includesPrevious: string[];
    try {
      includesPrevious = JSON.parse(includesAttr);
    } catch (e) {
      console.error("OfferIncludesBadges: invalid includes attribute", e);
      return;
    }

    const badges = includesPrevious.map((offerId) => {
      const offer = OFFERS.find((o) => o.id === offerId);
      if (!offer) return "";

      const bgColor = offerId === "diagnosis" ? "blue" : "indigo";
      return `
        <div class="p-3 bg-${bgColor}-50 border-l-4 border-${bgColor}-500 rounded">
          <p class="text-sm font-semibold text-${bgColor}-900">
            <span data-en="✓ Includes everything in ${offer.title.en}"
                  data-lv="✓ Ietver visu no ${offer.title.lv}"
                  data-it="✓ Include tutto dalla ${offer.title.it}">
              ✓ Includes everything in ${offer.title.en}
            </span>
          </p>
        </div>
      `;
    }).join("");

    this.innerHTML = `<div class="mb-4 space-y-2">${badges}</div>`;
  }
}

customElements.define("offer-includes-badges", OfferIncludesBadges);

export { OfferIncludesBadges };

